var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDesk48Line = function SvgIconDesk48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 13.15H9v3.4h2.3v18.3h3.4v-4.3h18.6v4.3h3.4v-18.3H39v-3.4Zm-5.7 14H14.7v-10.6h18.6v10.6Z",
    fill: "current"
  })));
};
export default SvgIconDesk48Line;